import React from 'react';
import { Accordion } from 'semantic-ui-react';
import Pane from './components/Pane';
import './CheckoutAccordion.css';
var defaultProps = {
  className: ''
};
function CheckoutAccordion(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(Accordion, {
    fluid: true,
    styled: true,
    className: "checkout-accordion ".concat(className)
  }, children);
}
CheckoutAccordion.defaultProps = defaultProps;
CheckoutAccordion.Pane = Pane;
export default CheckoutAccordion;